import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { ReportParagraphsApiImpl } from './apis/impls/report-paragraphs-api';
import { ReportParagraphsRepositoryImpl } from './repositories/impls/report-paragraphs-repository';
import { GetReportParagraphsApi } from './apis/report-paragraphs-api';
import { ReportParagraphsRepository } from './services/report-paragraphs-repository';
import { ReportParagraphsService } from './services/report-paragraphs-service';
import { ReportParagraphsServiceImpl } from './services/impls/report-paragraphs-service';
import { StartCheckContentApi } from './apis/start-check-content-api';
import { CheckContentService } from './services/check-content-service';
import { CheckContentServiceImpl } from './services/impls/check-content-service';
import { GetCheckContentApi } from './apis/get-check-content-api';
import { ProofReadingOrchestrationServiceImpl } from './services/impls/proof-reading-orchestration-service';
import { ProofReadingOrchestrationService } from './services/proof-reading-orchestration-service';
import { ProofReadingProgressServiceImpl } from './services/impls/proof-reading-progress-service';
import { ProofReadingProgressService } from './services/proof-reading-progress-service';
import { BatchIgnoreApi } from './apis/batch-ignore-api';
import { FixContentApi } from './apis/fix-content-api';
import { BatchIgnoreService } from './services/batch-ignore-service';
import { BatchIgnoreServiceImpl } from './services/impls/batch-ignore-service';
import { ParagraphFixService } from './services/paragraph-fix-service';
import { ParagraphFixServiceImpl } from './services/impls/paragraph-fix-service';
import { IssuesManagementService } from './services/issues-management-service';
import { IssuesManagementServiceImpl } from './services/impls/issues-management-service';
import { UpdateContentApi } from './apis/update-content-api';
import { CheckStatisticsApi } from './apis/check-statistics-api';
import { CheckStatisticsServiceImpl } from './services/impls/check-statistics-service';
import { CheckStatisticsService } from './services/check-statistics-service';
import { ParagraphReplacementService } from './services/paragraph-replacement-service';
import { ParagraphReplacementServiceImpl } from './services/impls/paragraph-replacement-service';
import { ChapterOperations } from './services/chapter-operations';
import { ChapterOperationsAdapter } from './services/impls/chapter-operations-adapter';

export const proofReadingModule = (bind: interfaces.Bind) => {
    bind(ReportParagraphsApiImpl).toSelf();
    bind(GetReportParagraphsApi).toService(ReportParagraphsApiImpl);
    bind(StartCheckContentApi).toService(ReportParagraphsApiImpl);
    bind(GetCheckContentApi).toService(ReportParagraphsApiImpl);
    bind(BatchIgnoreApi).toService(ReportParagraphsApiImpl);
    bind(FixContentApi).toService(ReportParagraphsApiImpl);
    bind(UpdateContentApi).toService(ReportParagraphsApiImpl);
    bind(CheckStatisticsApi).toService(ReportParagraphsApiImpl);
    bind(ReportParagraphsRepository).to(ReportParagraphsRepositoryImpl);
    bind(ReportParagraphsService).to(ReportParagraphsServiceImpl);
    bind(CheckContentService).to(CheckContentServiceImpl);
    bind(ProofReadingOrchestrationService).to(ProofReadingOrchestrationServiceImpl);
    bind(ProofReadingProgressService).to(ProofReadingProgressServiceImpl);
    bind(BatchIgnoreService).to(BatchIgnoreServiceImpl);
    bind(ParagraphFixService).to(ParagraphFixServiceImpl);
    bind(IssuesManagementService).to(IssuesManagementServiceImpl);
    bind(CheckStatisticsService).to(CheckStatisticsServiceImpl);
    bind(ParagraphReplacementService).to(ParagraphReplacementServiceImpl);
    bind(ChapterOperations).to(ChapterOperationsAdapter);
};
